import {Component, Input, OnInit} from '@angular/core';
import {ContactDetailsResponse, ReferenceBookType} from '@npck/af-frontend-api';
import {DictionaryHolderService} from '../../../../../../../domain/dictionary-holder.service';
import {mapToViewModel} from '../../../../../../../components/files/file-preview/file-preview.component';
import {AttachmentViewModel} from '../../../../documents-tab/documents-tab.component';

@Component({
    selector: 'af-contact-files-tab',
    templateUrl: 'contact-files-tab.component.html',
    styleUrl: 'contact-files-tab.component.scss',
    standalone: false,
})
export class ContactFilesTabComponent implements OnInit {
    @Input() contactDetails: ContactDetailsResponse;
    attachments: AttachmentViewModel[] = [];

    constructor(private dictionaryHolderService: DictionaryHolderService) {
    }

    ngOnInit(): void {
        if (!this.contactDetails.attachments?.length) {
            return;
        }
        this.dictionaryHolderService.getReference(ReferenceBookType.ATTACHED_DOC)
            .subscribe(docTypes => {
                this.attachments = this.contactDetails.attachments
                    .map(attachment => mapToViewModel(attachment, docTypes))
                    .filter(a => a.files?.length > 0);
            });
    }
}
